var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26609 12.4957L5.22609 9.64348H8.76L9.72 12.4957H11L7.61913 3H6.38087L3 12.4957H4.26609ZM7.01391 4.43304L8.43304 8.66261H5.55304L6.97913 4.43304H7.01391Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1463 2.6365C12.1463 2.62142 12.1463 2.59125 12.1463 2.56109C12.1463 2.22926 12.3801 1.94268 12.7647 1.94268C13.1192 1.94268 13.3831 2.1991 13.3831 2.52338C13.3831 2.88537 13.1116 3.17195 12.8627 3.42081L11.0754 5.25339V6H14.6652V5.04223H12.7421V4.99698L13.7149 3.95626C14.1297 3.51885 14.5822 3.11161 14.5822 2.41026C14.5822 1.61086 13.8808 1 12.7949 1C11.5656 1 11 1.7994 11 2.57617V2.6365H12.1463Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperscription);
export default __webpack_public_path__ + "static/media/superscription.01e84379bc353c83cc6c357e4f7b90e3.svg";
export { ForwardRef as ReactComponent };